var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.601 8.68255L13.3165 9.39801L6.2708 16.4437H5.55534V15.7282L12.601 8.68255ZM15.4006 4.00098C15.2062 4.00098 15.004 4.07874 14.8563 4.2265L13.4331 5.64964L16.3494 8.5659L17.7725 7.14276C18.0758 6.83947 18.0758 6.34954 17.7725 6.04625L15.9528 4.2265C15.7973 4.07097 15.6028 4.00098 15.4006 4.00098ZM12.601 6.48174L4 15.0828V17.999H6.91626L15.5173 9.39801L12.601 6.48174Z",
    fill: "#00C8D5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/EditIcon.57bcd11eae34df89f6c91332a0fbf5c1.svg";
export { ForwardRef as ReactComponent };